import { data } from 'services';
import { getDateTime, getDuration } from 'services/types';
import { SoundPlayer, Cell } from 'libs/ui';

/**
 * get app number
 * @returns
 */
const getAppNumber = (val) => {
  const racksMap = data.getRacksMap();
  return (racksMap && racksMap[val]) || val;
};

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      // {
      //   name: 'dcontext',
      //   title: t('dict_filter.Тип'),
      //   width: 110,
      //   render: (val) => data.getDictValue('calls.type', val),
      // },
      {
        name: 'disposition',
        title: t('grid.Статус'),
        width: 150,
        render: (val) => data.getDictValue('calls.status', val),
      },
      { name: 'calldate', title: t('grid.Время'), width: 210, render: (val) => getDateTime(val) },
      { name: 'duration', title: t('grid.Длительность'), width: 185, render: (val) => getDuration(val, true) },
      { name: 'source_type', title: t('grid.Оборудование'), width: 150, render: (val) => data.getDictValue('rack_type', val) },
      { name: 'source', title: t('grid.№ устройства'), render: (val) => getAppNumber(val) },
      {
        name: 'disposition',
        title: t('grid.Послушать/скачать'),
        width: 155,
        renderCell: true,
        render: (_val, params, row) => (
          <Cell {...params} fullh>
            <SoundPlayer row={row} />
          </Cell>
        ),
      },
    ];

    return fields;
  };

  return { getFields };
};
